import { connect } from "react-redux";
import NetsuiteConfigurationView from "./NetsuiteConfigurationView.jsx";
import { updateConfiguration, deactivateNetsuiteIntegration } from "src/legacy/redux/actions/integrations/netsuite.jsx";

const mapStateToProps = (state, ownProps) => {
  return {
    authenticating:state.legacyRootReducer.settings.integrations.netsuite.authentication.authenticating,
    errors: state.legacyRootReducer.settings.integrations.netsuite.changes.error,
    updating: state.legacyRootReducer.settings.integrations.netsuite.changes.saving,
    loading: state.legacyRootReducer.settings.integrations.netsuite.changes.loading,
    user: state.users.me,
    loadingFields: state.legacyRootReducer.settings.integrations.activated.opportunityFields.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateConfiguration: (configuration) => {
      return dispatch(updateConfiguration(configuration));
    },
    deactivateNetsuiteIntegration: (type) =>{
      return dispatch(deactivateNetsuiteIntegration(type));
    }
  };
};

const NetsuiteConfigurationPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(NetsuiteConfigurationView);

export default NetsuiteConfigurationPage;
